import {
  clearStoredSession,
  getLastActivity,
  INACTIVITY_TIMEOUT_MS,
} from "./sessionStorage";

const getUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const lastActivity = getLastActivity();

    if (
      user &&
      typeof user.userName === "string" &&
      user.userName &&
      lastActivity !== null &&
      Date.now() - lastActivity < INACTIVITY_TIMEOUT_MS
    ) {
      return user;
    }
  } catch {
    // Invalid stored data should require signing in again.
  }

  clearStoredSession();
  return null;
};

export default getUser;
